<script>
import { layoutMethods } from "@/state/helpers";
import animationData from "@/components/widgets/etwtznjn.json";
import Lottie from "@/components/widgets/lottie.vue";
export default {
  methods:{
    ...layoutMethods
    
  },
  created(){
    this.changeLayoutType({ layoutType: 'full' });
  },
  data() {
        return {
            defaultOptions: { animationData: animationData },
        };
    },
    components: {
        lottie: Lottie
    }
};
</script>

<template>
  <div class="auth-page-wrapper pt-5">

    <div class="auth-one-bg-position auth-one-bg" id="auth-particles">
      <div class="bg-overlay"></div>

      <div class="shape">

        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 1440 120">
          <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
        </svg>
      </div>
    </div>

    <div class="auth-page-content">
      <BContainer>
                <BRow class="justify-content-start">
                    <BCol xl="7">
                        <BCard no-body class="overflow-hidden">
                            <BCardBody class="p-4">
                                <div class="text-center">
                                    <lottie colors="primary:#405189,secondary:#0ab39c" :options="defaultOptions"
                                        style="height:7.5rem;width:7.5rem;" />
                                    <h1 class="text-primary mb-4">Oops !</h1>
                                    <h4 class="text-uppercase">Sorry, Page not Found 😭</h4>
                                    <p class="text-muted mb-4">Ulaşmak istediğiniz sayfaya yetkiniz bulunmamaktadır!</p>
                                    <router-link to="/" class="btn btn-success"><i class="mdi mdi-home me-1"></i>Anasayfaya Dön</router-link>
                                </div>
                            </BCardBody>
                        </BCard>
                    </BCol>
                </BRow>
            </BContainer>
    </div>

  </div>
</template>
